<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-box">
      <h3 class="modal-title">{{ t('jobDetails') }}</h3>
      <table class="detail-table">
        <tr><th>{{ t('jobCode') }}</th><td>{{ formatJobCode(job.id) }}</td></tr>
        <tr v-if="job.file_name">
          <th>{{ t('file') }}</th>
          <td>
            <a :href="`${API_URL}/uploads/${encodeURIComponent(job.file_name)}`" target="_blank">
              {{ extractOriginalFileName(job.file_name) }}
            </a>
          </td>
        </tr>
        <tr><th>{{ t('desc') }}</th><td>{{ job.description || t('none') }}</td></tr>
        <tr><th>{{ t('languages') }}</th><td>{{ job.source_lang }} → {{ job.target_lang }}</td></tr>
        <tr><th>{{ t('customer') }}</th><td>{{ job.user_name }} {{ job.user_surname }}</td></tr>
        <tr v-if="job.translation_type"><th>{{ t('translationType') }}</th><td>{{ job.translation_type }}</td></tr>
        <tr><th>{{ t('specialization') }}</th><td>{{ job.specialization || '-' }}</td></tr>
        <tr v-if="job.hat_tur_name"><th>{{ t('hatType') }}</th><td>{{ job.hat_tur_name }}</td></tr>
        <tr><th>{{ t('deliveryDate') }}</th><td>{{ formatDate(job.delivery_date) }}</td></tr>
        <tr><th>{{ t('payment') }}</th>
          <td :style="{ color: job.is_paid ? 'green' : 'red' }">
            {{ job.is_paid ? t('paid') : t('pending') }}
          </td>
        </tr>
        <tr v-if="job.output_upload_date">
          <th>{{ t('uploadTime') }}</th>
          <td>{{ formatDate(job.output_upload_date) }}</td>
        </tr>
        <tr v-if="job.output_files?.length">
          <th>{{ t('outputFile') }}</th>
          <td>
            <ul>
              <li v-for="file in job.output_files" :key="file">
                <a
                  :href="`${API_URL}/uploads/output/${encodeURIComponent(file)}`"
                  target="_blank"
                >
                  {{ extractOriginalFileName(file) }}
                </a>
              </li>
            </ul>
          </td>
        </tr>
      </table>

      <div class="btn-row">
        <button class="btn" @click="$emit('close')">{{ t('close') }}</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const props = defineProps({ job: Object })
const emit = defineEmits(['close'])

const API_URL = process.env.VUE_APP_API_URL

function extractOriginalFileName(fileName) {
  return fileName?.replace(/^\d+-/, '') || '-'
}

function formatJobCode(id) {
  return 'JOB-' + String(id).padStart(6, '0')
}

function formatDate(dateStr) {
  if (!dateStr) return '-'
  const d = new Date(dateStr)
  return d.toLocaleDateString('tr-TR') // örnek: 02.06.2025
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}
.modal-box {
  background: #fff;
  padding: 24px 32px;
  border-radius: 10px;
  width: 90%;
  max-width: 620px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
}
.modal-title {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
}
.detail-table {
  width: 100%;
  border-collapse: collapse;
}
.detail-table th {
  text-align: left;
  background-color: #f9f9f9;
  padding: 10px;
  width: 40%;
  font-weight: 600;
}
.detail-table td {
  padding: 10px;
}
.btn-row {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.btn {
  padding: 10px 20px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
@media (max-width: 600px) {
  .modal-box {
    padding: 16px 20px;
    border-radius: 8px;
  }

  .modal-title {
    font-size: 18px;
  }

  .detail-table th,
  .detail-table td {
    display: block;
    width: 100%;
    padding: 8px 0;
  }

  .detail-table th {
    background-color: transparent;
    font-weight: bold;
    margin-top: 10px;
  }

  .detail-table td {
    border-bottom: 1px solid #eee;
  }

  .btn {
    width: 100%;
    padding: 12px;
    font-size: 15px;
  }

  .btn-row {
    margin-top: 24px;
  }
}

</style>
